// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Textarea styles */
textarea[data-v-c63d0f7e] {
    width: 100%;
    background-color: RGBA(28, 32, 36);
    color: white;
    padding: 8px;
    box-sizing: border-box;
    font-family: monospace;
    resize: none;
    overflow: hidden;
    height: 15em;
    transition: color 0.3s ease;
}
.red-text[data-v-c63d0f7e] {
    color: red !important;
}
.green-text[data-v-c63d0f7e] {
    color: lightgreen !important;
}

/* Shake animation */
@keyframes shake-c63d0f7e {
0% {
        transform: translateX(0);
}
25% {
        transform: translateX(-5px);
}
50% {
        transform: translateX(5px);
}
75% {
        transform: translateX(-5px);
}
100% {
        transform: translateX(0);
}
}
.shake-animation[data-v-c63d0f7e] {
    animation: shake-c63d0f7e 0.5s ease;
    animation-iteration-count: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/CodeWidget.vue"],"names":[],"mappings":";AAwCA,oBAAoB;AACpB;IACI,WAAW;IACX,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;AAC/B;AAEA;IACI,qBAAqB;AACzB;AAEA;IACI,4BAA4B;AAChC;;AAEA,oBAAoB;AACpB;AACI;QACI,wBAAwB;AAC5B;AAEA;QACI,2BAA2B;AAC/B;AAEA;QACI,0BAA0B;AAC9B;AAEA;QACI,2BAA2B;AAC/B;AAEA;QACI,wBAAwB;AAC5B;AACJ;AAEA;IACI,mCAA0B;IAC1B,4BAA4B;AAChC","sourcesContent":["<template>\n    <div>\n        <textarea :value=\"modelValue\" @input=\"onInput\" ref=\"textarea\"></textarea>\n    </div>\n</template>\n<script>\nexport default {\n    name: 'CodeWidget',\n    props: {\n        modelValue: {\n            type: String,\n            required: true,\n        },\n    },\n    methods: {\n        onInput(event) {\n            this.$emit('update:modelValue', event.target.value); // Emit the updated value to the parent\n        },\n        shakeTextarea() {\n            const textarea = this.$refs.textarea;\n            textarea.classList.add('shake-animation', 'red-text'); // Add shake and red background\n\n            setTimeout(() => {\n                textarea.classList.remove('shake-animation', 'red-text'); // Remove classes after 2 seconds\n            }, 500);\n        },\n        greenTextarea() {\n            const textarea = this.$refs.textarea;\n\n            return new Promise((resolve, reject) => {\n                textarea.classList.add('green-text'); // Add shake and red background\n                setTimeout(() => {\n                    resolve();\n                }, 500);\n            })\n        },\n    },\n};\n</script>\n<style scoped>\n/* Textarea styles */\ntextarea {\n    width: 100%;\n    background-color: RGBA(28, 32, 36);\n    color: white;\n    padding: 8px;\n    box-sizing: border-box;\n    font-family: monospace;\n    resize: none;\n    overflow: hidden;\n    height: 15em;\n    transition: color 0.3s ease;\n}\n\n.red-text {\n    color: red !important;\n}\n\n.green-text {\n    color: lightgreen !important;\n}\n\n/* Shake animation */\n@keyframes shake {\n    0% {\n        transform: translateX(0);\n    }\n\n    25% {\n        transform: translateX(-5px);\n    }\n\n    50% {\n        transform: translateX(5px);\n    }\n\n    75% {\n        transform: translateX(-5px);\n    }\n\n    100% {\n        transform: translateX(0);\n    }\n}\n\n.shake-animation {\n    animation: shake 0.5s ease;\n    animation-iteration-count: 1;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
